import * as React from 'react'
import {DataObjectId} from 'yougile-model'
import {EventBus} from '../../../client/event-bus'
import {openChatEvent} from '../../../client/events'
import {TaskChatListContent} from './task-chat-list-content'

export class TaskChatList extends React.PureComponent {
  private itemClick = (chatId: DataObjectId) =>
    EventBus.dispatch(openChatEvent(chatId))

  public override render(): React.ReactNode {
    return <TaskChatListContent itemClick={this.itemClick} />
  }
}
